import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";

export default function AdminBanners() {
  const [banners, setBanners] = useState([]);
  const [form, setForm] = useState({ title: "", subtitle: "", image_url: "", cta_text: "Ver más", cta_link: "/catalogo", position: "hero", active: true });

  const load = async () => { const { data } = await api.get("/admin/banners"); setBanners(data); };
  useEffect(() => { load(); }, []);

  const create = async () => {
    try {
      await api.post("/admin/banners", form);
      toast.success("Banner creado");
      setForm({ title: "", subtitle: "", image_url: "", cta_text: "Ver más", cta_link: "/catalogo", position: "hero", active: true });
      load();
    } catch (e) { toast.error("Error"); }
  };
  const remove = async (id) => { await api.delete(`/admin/banners/${id}`); load(); };

  return (
    <div data-testid="admin-banners-page">
      <h1 className="font-serif text-5xl tracking-tighter">Banners</h1>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-8">
        <div className="bg-white border border-[#E8E3DA] p-6">
          <h2 className="font-serif text-2xl mb-4">Nuevo banner</h2>
          <div className="space-y-3">
            <input className="w-full border border-[#2C302E] bg-transparent px-3 py-2" placeholder="Título" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
            <input className="w-full border border-[#2C302E] bg-transparent px-3 py-2" placeholder="Subtítulo" value={form.subtitle} onChange={(e) => setForm({ ...form, subtitle: e.target.value })} />
            <input className="w-full border border-[#2C302E] bg-transparent px-3 py-2" placeholder="URL de imagen" value={form.image_url} onChange={(e) => setForm({ ...form, image_url: e.target.value })} />
            <input className="w-full border border-[#2C302E] bg-transparent px-3 py-2" placeholder="Texto CTA" value={form.cta_text} onChange={(e) => setForm({ ...form, cta_text: e.target.value })} />
            <input className="w-full border border-[#2C302E] bg-transparent px-3 py-2" placeholder="Link CTA" value={form.cta_link} onChange={(e) => setForm({ ...form, cta_link: e.target.value })} />
            <select className="w-full border border-[#2C302E] bg-transparent px-3 py-2" value={form.position} onChange={(e) => setForm({ ...form, position: e.target.value })}>
              <option value="hero">Hero</option>
              <option value="secondary">Secundario</option>
            </select>
            <button onClick={create} className="btn-primary w-full">Crear</button>
          </div>
        </div>

        <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4">
          {banners.map((b) => (
            <div key={b.id} className="bg-white border border-[#E8E3DA]">
              <img src={b.image_url} alt={b.title} className="aspect-video object-cover w-full" />
              <div className="p-4">
                <p className="font-serif text-lg">{b.title}</p>
                <p className="text-xs text-[#5B605E]">{b.subtitle}</p>
                <div className="flex justify-between items-center mt-2 text-xs">
                  <span className="uppercase">{b.position}</span>
                  <button onClick={() => remove(b.id)} className="hover:text-[#9E2A2B]"><Trash2 size={14}/></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
